import React, { useState } from "react";
import "./aboutUsPage.css";
import AboutUs from "./aboutUsComponent";
import RenderCLNScomponent from "./teamCLNSpage";
import RenderTandC from "./tandcpage";

const AboutUsPage = () => {
  const [activeQuadrant, setActiveQuadrant] = useState("About Us");
  const [text, setText] = useState(
    "Sample Text, intro of case just for identification purpose. 2 lines summary of case, intro of case just for identification purpose."
  );

  const handleTextChange = (e) => {
    setText(e.target.value);
  };



  const restParagraphs = () => {
    return (
      <div className="grid-container">
        <div>
          <textarea
            style={{ width: "100%" }}
            value={text}
            onChange={handleTextChange}
          ></textarea>
        </div>
        <div>
          <textarea
            style={{ width: "100%" }}
            value={text}
            onChange={handleTextChange}
          ></textarea>
        </div>
      </div>
    );
  };

  const renderQuadrant1 = () => {
    return (
    
    <AboutUs/>)
  };

  const renderCLNS = () => {
    return (
     <RenderCLNScomponent/>
    );
  };

  const renderTandC = () => {
    return (
      <>
       <RenderTandC/>
      </>
    );
  };

  const renderContent = () => {
    switch (activeQuadrant) {
      case "About Us":
        return renderQuadrant1();
      case "Team CLNS":
        return renderCLNS();
      case "Terms & Conditions":
        return renderTandC();
    }
  };

  return (
    <div className="about-us-page">
      <div className="content-container">
        <div className="buttons-container">
          {["About Us", "Team CLNS", "Terms & Conditions"].map(
            (quadrant, index) => (
              <button
                key={index}
                onClick={() => setActiveQuadrant(quadrant)}
                className={`quadrant-button ${
                  activeQuadrant === quadrant ? "active" : ""
                }`}
              >
                {quadrant}
              </button>
            )
          )}
        </div>
        {/* Content Rendering */}
        <div className="content-area">{renderContent()}</div>
      </div>

      {/* Footer Buttons Section */}
      {/* <div className="footer-buttons">
        <button
          className="reset-button"
          onClick={() => console.log("Reset Clicked")}
        >
          Reset
        </button>
        <button
          className="save-button"
          onClick={() => console.log("Save Clicked")}
        >
          Save
        </button>
      </div> */}
    </div>
  );
};

export default AboutUsPage;
